import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService, Core2Config, ApiVisa, 
         Pagination, PagingResponseModel, BasicApiResponseModel, ApiResponseModel } from '../../shared';
import { EngagementBillingHdrContainerModel } from '../../../../../../models/aggregates/erp/engagement';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EngagementBillingHdrService extends BaseApiTemplateService<EngagementBillingHdrContainerModel> {

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX + 'engagement-billing-hdrs';
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX + 'engagement-billing-hdrs';
        this.httpClient = http;
    }

    public get(visa: ApiVisa): Observable<ApiResponseModel<any>> {
        if (this.endpoint_path && visa.api_domain_url) {
          this.apiUrl = visa.api_domain_url + this.endpoint_path;
        }
        return this.httpClient.get<ApiResponseModel<any>>(
          this.apiUrl + '/backoffice-ep',
          this.getHttpHeader(visa)
        );
    }

    public getLoginEP(visa: ApiVisa): Observable<ApiResponseModel<any>> {
        if (this.endpoint_path && visa.api_domain_url) {
          this.apiUrl = visa.api_domain_url + this.endpoint_path;
        }
        return this.httpClient.get<ApiResponseModel<any>>(
          this.apiUrl + '/login-entity-ep',
          this.getHttpHeader(visa)
        );
    }

    public getByGuid(guid: string, visa: ApiVisa): Observable<BasicApiResponseModel<any>> {
        if (this.endpoint_path && visa.api_domain_url) {
          this.apiUrl = visa.api_domain_url + this.endpoint_path;
        }
        return this.httpClient.get<BasicApiResponseModel<any>>(
          this.apiUrl + '/backoffice-ep/' + guid,
          this.getHttpHeader(visa)
        );
    }

    public getByGuidLoginEntityEP(guid: string, visa: ApiVisa): Observable<BasicApiResponseModel<any>> {
        if (this.endpoint_path && visa.api_domain_url) {
            this.apiUrl = visa.api_domain_url + this.endpoint_path;
        }
        return this.httpClient.get<BasicApiResponseModel<any>>(
            this.apiUrl + '/login-entity-ep/' + guid,
            this.getHttpHeader(visa)
        );
    }
    
    public getByCriteria(pagination: Pagination, visa: ApiVisa, criteria?: any): Observable<PagingResponseModel<any>> {
        if (this.endpoint_path && visa.api_domain_url) {
            this.apiUrl = visa.api_domain_url + this.endpoint_path;
        }
        const UrlByCriteria =
            this.apiUrl + '/backoffice-ep/query?' + pagination.getQueryKeyValues();
        return this.httpClient.get<PagingResponseModel<any>>(
            UrlByCriteria,
            this.getHttpHeader(visa)
        );
    }

    public getByCriteriaLoginEntityEP(pagination: Pagination, visa: ApiVisa, criteria?: any): Observable<PagingResponseModel<any>> {
        if (this.endpoint_path && visa.api_domain_url) {
          this.apiUrl = visa.api_domain_url + this.endpoint_path;
        }
        const UrlByCriteria =
          this.apiUrl + '/login-entity-ep/query?' + pagination.getQueryKeyValues();
        return this.httpClient.get<PagingResponseModel<any>>(
          UrlByCriteria,
          this.getHttpHeader(visa)
        );
    }

    public delete(guid: string, visa: ApiVisa): Observable<ApiResponseModel<any>> {
        if (this.endpoint_path && visa.api_domain_url) {
            this.apiUrl = visa.api_domain_url + this.endpoint_path;
        }
        return this.httpClient.delete<ApiResponseModel<any>>(
            this.apiUrl + '/backoffice-ep/' + guid,
            this.getHttpHeader(visa)
        );
    }

    public deleteLoginEntityEP(guid: string, visa: ApiVisa): Observable<ApiResponseModel<any>> {
        if (this.endpoint_path && visa.api_domain_url) {
            this.apiUrl = visa.api_domain_url + this.endpoint_path;
        }
        return this.httpClient.delete<ApiResponseModel<any>>(
            this.apiUrl + '/login-entity-ep/' + guid,
            this.getHttpHeader(visa)
        );
    }

    public put(dtoObject: any, visa: ApiVisa): Observable<BasicApiResponseModel<any>> {
        if (this.endpoint_path && visa.api_domain_url) {
            this.apiUrl = visa.api_domain_url + this.endpoint_path;
        }
        return this.httpClient.put<BasicApiResponseModel<any>>(
            this.apiUrl + '/backoffice-ep',
            dtoObject,
            this.getHttpHeader(visa)
        );
    }

    public putLoginEntityEP(dtoObject: any, visa: ApiVisa): Observable<BasicApiResponseModel<any>> {
        if (this.endpoint_path && visa.api_domain_url) {
            this.apiUrl = visa.api_domain_url + this.endpoint_path;
        }
        return this.httpClient.put<BasicApiResponseModel<any>>(
            this.apiUrl + '/login-entity-ep',
            dtoObject,
            this.getHttpHeader(visa)
        );
    }

    public post(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
        if (this.endpoint_path && visa.api_domain_url) {
            this.apiUrl = visa.api_domain_url + this.endpoint_path;
        }
        return this.httpClient.post<ApiResponseModel<any>>(
            this.apiUrl + '/backoffice-ep',
            dtoObject,
            this.getHttpHeader(visa)
        );
    }

    public postLoginEntityEP(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
        if (this.endpoint_path && visa.api_domain_url) {
            this.apiUrl = visa.api_domain_url + this.endpoint_path;
        }
        return this.httpClient.post<ApiResponseModel<any>>(
            this.apiUrl + '/login-entity-ep',
            dtoObject,
            this.getHttpHeader(visa)
        );
    }
}